"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserChairMapping_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var RecordStatus_1 = require("./RecordStatus");
var UserChairMapping_Factory = /** @class */ (function () {
    function UserChairMapping_Factory() {
    }
    UserChairMapping_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ChairId: model.ChairId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RecordStatus1: RecordStatus_1.RecordStatus_Factory.CreateIncoming(model.RecordStatus1),
            UserId: model.UserId,
        };
        return result;
    };
    UserChairMapping_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ChairId: model.ChairId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RecordStatus1: RecordStatus_1.RecordStatus_Factory.CreateOutgoing(model.RecordStatus1),
            UserId: model.UserId,
        };
        return result;
    };
    return UserChairMapping_Factory;
}());
exports.UserChairMapping_Factory = UserChairMapping_Factory;
